<!-- Heading -->
<mdb-card class="mb-4 wow fadeIn">
  <!--Card content-->
  <mdb-card-body class="d-sm-flex justify-content-between m-2 p-2">
    <div class="md-form col-sm-12 col-md-3 col-lg-3 m-1">
      <input
        [(ngModel)]="usersSearchRequest.searchTerm"
        mdbInput
        name="searchTerm"
        type="text"
        id="searchTerm"
        (keyup.enter)="SearchUsers()"
        class="form-control"
        #searchTerm="ngModel"
        required
      />
      <label for="searchTerm">Search</label>
    </div>
    <div class="md-form col-sm-12 col-md-6 col-lg-6 text-right">
      <button mdbBtn size="sm" class="my-0 p btn-trakly" (click)="ShowModal(null, 'newUserModal')">New User</button>
      <button mdbBtn size="sm" class="my-0 p btn-trakly" (click)="ExportToExcel()" [disabled]="busy || usersSearchResult.length === 0">
        <mdb-icon fas icon="file-excel"></mdb-icon> Export
      </button>
      <button mdbBtn size="sm" class="my-0 p btn-trakly-action" (click)="SearchUsers()">Search</button>
    </div>
  </mdb-card-body>
</mdb-card>
<!-- Heading -->

<!-- Heading -->
<mdb-card class="mb-4 wow fadeIn">
  <!--Card content-->
  <mdb-card-body class="d-sm-flex justify-content-between">
    <!-- Form -->
    <div class="text-center p-1 w-100">
      <div *ngIf="!busy">
        <!--Error Display-->
        <div class="col">
          <div *ngIf="showError" class="alert alert-danger text-center font-weight-bold" role="alert">
            {{ errorMsg }}
          </div>
        </div>
        <div class="md-form col-sm-12 col-md-1 col-lg-2 px-1" style="margin-top: 5px">
          <select
            class="md-form form-control browser-default w-100"
            id="tagFilter"
            placeholder="Filter Tags"
            [(ngModel)]="selectedTagFilterId"
            (change)="filterByTagId()"
          >
            <option *ngFor="let tag of tagFilter; trackBy: trackById" [ngValue]="tag.id">
              {{ tag.name }}
            </option>
          </select>
          <label for="tagFilter" class="active">Tag Filter</label>
        </div>
        <div class="table-responsive" style="overflow: visible">
          <table class="table table-sm" mdbTable *ngIf="!busy" hover="true" small="true" stickyHeader="true">
            <thead>
              <tr>
                <th scope="col" class="text-left">User Id</th>
                <th scope="col" class="text-left">Full Name</th>
                <th scope="col" class="text-left">Email</th>
                <th scope="col" class="text-left">SA ID Number</th>
                <th scope="col" class="text-left">Cellphone</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr mdbTableCol *ngFor="let user of usersSearchResult">
                <td class="text-left" scope="row">{{ user.id }}</td>
                <td class="text-left">
                  {{ user.fullName }}
                  <div style="margin-top: 10px; font-size: smaller; display: flex; justify-content: space-between">
                    <span class="text-left"></span>
                    <span class="text-right" style="max-width: 150px">
                      <app-tags [Tags]="user.tags" (TagError)="parseAndDisplayError($event)"> </app-tags>
                    </span>
                  </div>
                </td>
                <td class="text-left">{{ user.email }}</td>
                <td class="text-left">{{ user.idNumber }}</td>
                <td class="text-left">{{ user.mobile }}</td>
                <td>
                  <div class="btn-group" mdbDropdown>
                    <button
                      type="button"
                      mdbBtn
                      size="sm"
                      class="waves-light btn-trakly"
                      (click)="ShowModal(user.id, 'userInfoModal')"
                      mdbWavesEffect
                    >
                      <mdb-icon far icon="user-circle"></mdb-icon> Profile
                    </button>
                    <button
                      mdbDropdownToggle
                      size="sm"
                      mdbBtn
                      class="dropdown-toggle waves-light btn-trakly"
                      type="button"
                      mdbWavesEffect
                    ></button>

                    <div class="dropdown-menu dropdown-primary">
                      <a class="dropdown-item" size="sm" (click)="ShowModal(user.id, 'tradeSummary')" mdbWavesEffect>
                        <mdb-icon far icon="file-alt"></mdb-icon> Trade Summary
                      </a>
                      <a class="dropdown-item" size="sm" (click)="ShowModal(user.id, 'tradeHistory')" mdbWavesEffect>
                        <mdb-icon fas icon="list-ol"></mdb-icon> Trade History
                      </a>
                      <div class="dropdown-divider"></div>
                      <a class="dropdown-item" size="sm" (click)="ShowModal(user.id, 'userDocumentsModal')" mdbWavesEffect>
                        <mdb-icon far icon="file-alt"></mdb-icon> User Documents
                      </a>
                      <a class="dropdown-item" size="sm" (click)="ShowModal(user.id, 'userFiaDocumentsModal')" mdbWavesEffect>
                        <mdb-icon far icon="file-alt"></mdb-icon> FIA Documents
                      </a>
                      <div class="dropdown-divider"></div>
                      <a class="dropdown-item" size="sm" (click)="ShowModal(user.id, 'userFiaApplicationModal')" mdbWavesEffect>
                        <mdb-icon fas icon="plus"></mdb-icon> FIA Application
                      </a>
                      <a class="dropdown-item" size="sm" (click)="ShowModal(user.id, 'userFiaApplicationsModal')" mdbWavesEffect>
                        <mdb-icon far icon="list-alt"></mdb-icon> FIA Applications
                      </a>
                      <a class="dropdown-item" size="sm" (click)="ShowModal(user.id, 'userFiaPinModal')" mdbWavesEffect>
                        <mdb-icon fas icon="plus"></mdb-icon> FIA Pin
                      </a>
                      <a class="dropdown-item" size="sm" (click)="ShowModal(user.id, 'userFiaPinsModal')" mdbWavesEffect>
                        <mdb-icon far icon="list-alt"></mdb-icon> FIA Pins
                      </a>
                      <div *ngIf="roleId === 1">
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" size="sm" (click)="ShowModalPopUp(user, 'createNewTradeModal')" mdbWavesEffect>
                          <mdb-icon far icon="list-alt"></mdb-icon> Create New Trade
                        </a>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!--Loading-->
      <div class="col-12 text-center" *ngIf="busy">
        <div *ngIf="busy" class="spinner-grow text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </mdb-card-body>
</mdb-card>

<app-user-profile-modal
  [selectedUserDetails]="selectedUserFullDetails"
  [(showModal)]="showUserProfileModal"
  (onModelChange)="SearchUsers()"
></app-user-profile-modal>

<app-user-documents
  [selectedUserProfile]="selectedUserProfile"
  [(showModal)]="showUserDocumentsModal"
  [userDocuments]="selectedUserDocuments"
></app-user-documents>

<app-fia-applications
  [selectedUserProfile]="selectedUserProfile"
  [selectedUserFiaApplcations]="selectedUserFiaApplcations"
  [(showModal)]="showUserFiaApplicationsModal"
>
</app-fia-applications>

<app-fia-application
  [selectedUserProfile]="selectedUserProfile"
  [(showModal)]="showUserFiaApplicationModal"
  [(fiaApplications)]="selectedUserFiaApplcations"
  (onModelChange)="SearchUsers()"
></app-fia-application>

<app-user-fia-pin [selectedUserProfile]="selectedUserProfile" [(showModal)]="showUserFiaPinModal"></app-user-fia-pin>

<app-fia-pins
  [selectedUserProfile]="selectedUserProfile"
  [(showModal)]="showUserFiaPinsModal"
  [selectedUserFiaPins]="selectedUserFiaPins"
></app-fia-pins>

<app-fia-documents
  [selectedUserProfile]="selectedUserProfile"
  [(showModal)]="showUserFiaDocumentsModal"
  [userDocuments]="selectedUserFiaDocuments"
></app-fia-documents>

<app-new-user-modal [(showModal)]="showNewUserModal" (onModelChange)="SearchUsers()"></app-new-user-modal>

<app-user-trades [selectedUserProfile]="selectedUserProfile" [(showModal)]="showUserTradeHistoryModal"></app-user-trades>

<app-user-summary [selectedUserProfile]="selectedUserProfile" [(showModal)]="showUserSummaryModal"></app-user-summary>

<app-add-new-trade [(showModal)]="showCreateNewTradeModal" [user]="searchResult"></app-add-new-trade>
